// TODO: Add types for 'unknown' responses and 'any' parameters
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../network/api';
import { AxiosHeaders } from 'axios';

export const getPaddyBuyerList = createAsyncThunk<
  { data: unknown[]; totalCount: number },
  any
>('stakeholder/getPaddyBuyerList', async (params, thunkAPI) => {
  try {
    const { search, agronomist, subDistrict, sort, ...restParams } = {
      ...params,
    };
    const paddyBuyerParams = {
      ...(search && { 'name.contains': search }),
      ...(agronomist && { 'agName.in': agronomist }),
      ...(subDistrict && { 'subDistrict.in': subDistrict }),
      ...(sort && { sort }),
      ...restParams,
    };
    const response = await API.get('/paddy-buyers', {
      params: { ...paddyBuyerParams },
    });
    const headers = response.headers;
    const totalCount =
      headers instanceof AxiosHeaders &&
      headers.has('X-Total-Count') &&
      headers?.get('X-Total-Count');
    return {
      data: response.data,
      totalCount: totalCount ? Number(totalCount) : 0,
    };
  } catch (e: any) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const getFarmerGroupLeaderList = createAsyncThunk<unknown, any>(
  'stakeholder/getFarmerGroupLeaderList',
  async (params, thunkAPI) => {
    try {
      const { search, agronomist, subDistrict, sort, ...restParams } = {
        ...params,
      };
      const farmerGroupLeaderParams = {
        sort: 'createdAt,desc',
        ...(sort && { sort }),
        ...(search && { 'leaderName.contains': search }),
        ...(subDistrict && { 'subDistrict.in': subDistrict }),
        ...(agronomist && agronomist !== '-' && { 'agName.in': agronomist }),
        ...(agronomist && agronomist === '-' && { 'agName.specified': false }),
        ...restParams,
      };
      const response = await API.get('cubes/list', {
        params: farmerGroupLeaderParams,
      });
      const headers = response.headers;
      const totalCount =
        headers instanceof AxiosHeaders &&
        headers.has('X-Total-Count') &&
        headers?.get('X-Total-Count');
      return {
        data: response.data,
        totalCount: totalCount ? Number(totalCount) : 0,
      };
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getPaddyBuyerSubDistrict = createAsyncThunk<unknown, string>(
  'dashboard/getPaddyBuyerSubDistrict',
  async (country = 'Indonesia', thunkAPI) => {
    try {
      const url = '/paddy-buyers/subdistrict';
      const params = {
        country: country,
      };
      const response = await API.get(url, { params });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
